import {
	Breadcrumbs,
	BreadcrumbsSkeleton,
	IconButton,
} from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import {
	NavBarBreadcrumbWrapper,
	NavBarRightSideWrapper,
	NavBarWrapper,
} from '.';
import AddWidgetButton from '../../../pages/AnalyticsPage/components/Buttons/AddWidgetButton';
import { ExportReportCSVButton } from '../../../pages/AnalyticsPage/components/Buttons/ExportReportCSVButton';
import { useReportManagement } from '../../../pages/HomePage/hooks/useReportManagement';
import { useCheckAnalyticsWritePermission } from '../../../utils/authorization/roles';
import { DataQualityShareModal } from '../../DataQualityScore/DataQualityShareModal/DataQualityShareModal';
import { appShellStore } from '../store';

function AnalyticsPageNavBar() {
	const [modalOpen, setModalOpen] = useState(false);

	const {
		navBarUI: {
			analyticsPage: {
				showAddWidgetButton,
				downloadDataQualityScore: { downloadButtonVisible, dataQualityScore },
				reportTitle,
				reportId,
			},
		},
	} = appShellStore;

	const { report } = useReportManagement({
		type: 'analytics',
		id: reportId,
	});
	const readOnly = !useCheckAnalyticsWritePermission({ report });

	return (
		<>
			<NavBarWrapper>
				<NavBarBreadcrumbWrapper>
					{reportTitle === '' || reportId === '' ? (
						<BreadcrumbsSkeleton />
					) : (
						<Breadcrumbs
							crumbs={[
								{
									title: 'Analytics',
									href: '/analytics',
								},
								{
									title: reportTitle,
									href: `/analytics/${reportId}`,
								},
							]}
						/>
					)}
				</NavBarBreadcrumbWrapper>

				<NavBarRightSideWrapper>
					<ExportReportCSVButton />
					{!readOnly && <AddWidgetButton />}
					{downloadButtonVisible && (
						<IconButton
							variant="tertiary"
							iconName="upload"
							onClick={() => setModalOpen(true)}
						/>
					)}
				</NavBarRightSideWrapper>
			</NavBarWrapper>
			<DataQualityShareModal
				initialOpened={modalOpen}
				dataQualityScore={dataQualityScore}
				onClose={() => setModalOpen(false)}
			/>
		</>
	);
}

const ObservedAnalyticsPageNavBar = observer(AnalyticsPageNavBar);
export default ObservedAnalyticsPageNavBar;
